"use client";

import { c as _c } from "react/compiler-runtime";
import { resolveIpfsUrl } from "@/components/ipfs/IPFSContext";
import ArtistProfileHandle from "@/components/the-memes/ArtistProfileHandle";
import type { BaseNFT } from "@/entities/INFT";
import { useIdentity } from "@/hooks/useIdentity";
import Image from "next/image";
import Link from "next/link";
interface NowMintingHeaderProps {
  readonly cardNumber: number;
  readonly title: string;
  readonly artistHandle: string;
  readonly artistName: string;
}
export default function NowMintingHeader(t0) {
  const $ = _c(25);
  const {
    cardNumber,
    title,
    artistHandle,
    artistName
  } = t0;
  let t1;
  if ($[0] !== artistHandle) {
    t1 = {
      handleOrWallet: artistHandle,
      initialProfile: null
    };
    $[0] = artistHandle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  let t2;
  if ($[2] !== artistHandle) {
    t2 = artistHandle.trim();
    $[2] = artistHandle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasHandle = Boolean(t2);
  let t3;
  if ($[4] !== cardNumber) {
    t3 = <span className="tw-mb-2 tw-text-[11px] tw-uppercase tw-leading-4 tw-tracking-[0.2em] tw-text-iron-500">Card #{cardNumber}</span>;
    $[4] = cardNumber;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `/the-memes/${cardNumber}`;
  let t5;
  if ($[6] !== t4 || $[7] !== title) {
    t5 = <Link href={t4} className="tw-text-xl tw-font-semibold tw-leading-tight tw-text-iron-50 tw-no-underline tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-iron-200 sm:tw-text-2xl md:tw-text-3xl">{title}</Link>;
    $[6] = t4;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== artistName || $[10] !== profile) {
    t6 = profile?.pfp ? <Image src={resolveIpfsUrl(profile.pfp)} alt={artistName} width={24} height={24} className="tw-size-6 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-900 tw-object-contain" /> : <div className="tw-size-6 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-900 tw-object-contain" />;
    $[9] = artistName;
    $[10] = profile;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== artistHandle || $[13] !== artistName || $[14] !== hasHandle) {
    t7 = hasHandle ? <ArtistProfileHandle nft={{
      artist_seize_handle: artistHandle
    } as BaseNFT} /> : artistName;
    $[12] = artistHandle;
    $[13] = artistName;
    $[14] = hasHandle;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <span className="tw-text-md tw-font-semibold tw-text-white tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-opacity-80">{t7}</span>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="tw-mt-4 tw-flex tw-items-center tw-gap-2">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t9) {
    t10 = <div className="tw-flex tw-flex-col">{t3}{t5}{t9}</div>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}